import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dayName',
  standalone: true
})
export class DayNamePipe implements PipeTransform {
  private names: Record<number, string> = {
    1: 'Ponedeljak', 2: 'Utorak', 3: 'Sreda',
    4: 'Četvrtak', 5: 'Petak', 6: 'Subota', 7: 'Nedelja'
  };

  transform(value: number): string {
    return this.names[value] || 'Nepoznat dan';
  }
}
